import React from "react";
import { registerExtension, EXTENSION_SORT_ORDER } from "@core/components/PipelineComponents/ExtensionProvider";
import { TooltipWrapper } from "@core/components/TooltipWrapper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/pro-light-svg-icons";
import { Switch } from "@core/components/ui/switch";
import { Label } from "@core/components/ui/label";
import { Button } from "@core/components/ui/button";

const ProductsComponent = () => {
  // Local state for toggles (not connected to settings yet)
  const [variantsEnabled, setVariantsEnabled] = React.useState<boolean>(true);
  const [reviewsEnabled, setReviewsEnabled] = React.useState<boolean>(true);
  const [relatedProductsEnabled, setRelatedProductsEnabled] = React.useState<boolean>(true);

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Products</h3>
      <p className="text-sm text-muted-foreground italic">
        This functionality needs clarification before implementing
      </p>
      <div className="space-y-4">
        {/* Product Variants Toggle */}
        <div className="space-y-2">
          <div className="flex items-center space-x-2">
            <Switch
              id="productVariants"
              checked={variantsEnabled}
              onCheckedChange={setVariantsEnabled}
            />
            <div className="flex items-center gap-2">
              <Label htmlFor="productVariants" className="cursor-pointer">
                Will your website use product variants?
              </Label>
              <TooltipWrapper
                tooltipContent="Variants allow for multiple products to be listed under a single master product (Ex Master product = Nike Shoe, variant 1 = Nike Shoe Color Red Size 10, variant 2 = Nike Shoe Color Blue Size 12)"
              >
                <FontAwesomeIcon
                  icon={faQuestionCircle}
                  className="text-muted-foreground cursor-help"
                />
              </TooltipWrapper>
            </div>
          </div>
          {variantsEnabled && (
            <div className="ml-10">
              <Button type="button" variant="outline">
                Create sample product variants
              </Button>
            </div>
          )}
        </div>

        {/* Reviews Toggle */}
        <div className="flex items-center space-x-2">
          <Switch
            id="productReviews"
            checked={reviewsEnabled}
            onCheckedChange={setReviewsEnabled}
          />
          <div className="flex items-center gap-2">
            <Label htmlFor="productReviews" className="cursor-pointer">
              Will your website use reviews?
            </Label>
            <TooltipWrapper
              tooltipContent="Allow customers to submit reviews for products. Reviews must be approved by admins before being displayed to users"
            >
              <FontAwesomeIcon
                icon={faQuestionCircle}
                className="text-muted-foreground cursor-help"
              />
            </TooltipWrapper>
          </div>
        </div>

        {/* Related Products Toggle */}
        <div className="flex items-center space-x-2">
          <Switch
            id="relatedProducts"
            checked={relatedProductsEnabled}
            onCheckedChange={setRelatedProductsEnabled}
          />
          <div className="flex items-center gap-2">
            <Label htmlFor="relatedProducts" className="cursor-pointer">
              Will your website support related products?
            </Label>
            <TooltipWrapper
              tooltipContent="Related products appear as alternative options for purchase related to the product being viewed"
            >
              <FontAwesomeIcon
                icon={faQuestionCircle}
                className="text-muted-foreground cursor-help"
              />
            </TooltipWrapper>
          </div>
        </div>
      </div>
    </div>
  );
};

registerExtension(
  "admin.system.sitesetup.siteconfiguration",
  ProductsComponent,
  "Products",
  false,
  EXTENSION_SORT_ORDER.HIGH + 150  // Display after Carts (HIGH + 125)
);
